import { createContext } from 'react';
import { useMemo, useRef, useState } from 'react';

const AbsenceTimelineContext = createContext();

function AbsencesTimelineProvider({ children }) {
  const [view, setView] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const calendarRef = useRef(null);
  const value = useMemo(() => ({
    view,
    setView,
    selectedSlot,
    setSelectedSlot,
    calendarRef,
  }), [view, selectedSlot]);

  return (
    <AbsenceTimelineContext value={value}>
      {children}
    </AbsenceTimelineContext>
  );
};


export { AbsencesTimelineProvider, AbsenceTimelineContext };
